import supabase from './supabaseClient';

/* Lightweight analytics util — fire-and-forget, never throws */

/* Session ID — persists for the browser tab session */
function getSessionId() {
  const key = 'zen_session_id';
  let id = sessionStorage.getItem(key);
  if (!id) {
    id = (typeof crypto !== 'undefined' && crypto.randomUUID)
      ? crypto.randomUUID()
      : Math.random().toString(36).slice(2) + Date.now().toString(36);
    sessionStorage.setItem(key, id);
  }
  return id;
}

/* Parse UTM params from current URL */
function getUtmParams() {
  const p = new URLSearchParams(window.location.search);
  const utm = {};
  ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'].forEach(k => {
    if (p.get(k)) utm[k] = p.get(k);
  });
  return Object.keys(utm).length ? utm : undefined;
}

/**
 * trackEvent — send one analytics event to Supabase.
 * @param {string} eventType   e.g. 'page_view', 'cta_click'
 * @param {object} eventData   arbitrary payload
 */
export function trackEvent(eventType, eventData = {}) {
  try {
    const utm = getUtmParams();
    const payload = {
      session_id:  getSessionId(),
      event_type:  eventType,
      event_data:  utm ? { ...eventData, ...utm } : eventData,
      referrer:    document.referrer || null,
      user_agent:  navigator.userAgent || null,
    };

    /* Fire-and-forget — intentionally not awaited */
    supabase
      .from('analytics_events')
      .insert(payload)
      .then(({ error }) => {
        if (error) console.warn('[analytics] insert failed:', error.message);
      });
  } catch (e) {
    /* Never let analytics break the UI */
    console.warn('[analytics] error:', e);
  }
}
